

const creativeServices = [
  {
    slug: "graphic-design",
    title: "Graphic Design",
    icon: "PenTool",
    iconBg: "",
    summary:
      "Logos, brand identities, social media creatives and print designs that make your business stand out.",
    intro: [
      "Great design is how people remember you. Our graphic design team creates visuals that communicate your brand clearly and consistently across every touchpoint, from your logo to your Instagram feed.",
      "Whether you are launching a new brand or refreshing an existing one, we work closely with you to understand your audience and deliver designs that look great and drive results.",
    ],
    offerings: [
      { icon: "Hexagon", title: "Logo & Brand Identity", text: "Unique logos, colour palettes, typography and complete brand guidelines." },
      { icon: "Instagram", title: "Social Media Creatives", text: "Scroll-stopping posts, stories, banners and ad creatives for every platform." },
      { icon: "FileText", title: "Print Design", text: "Brochures, flyers, posters, business cards, menus and packaging." },
      { icon: "Monitor", title: "UI & Web Graphics", text: "Website banners, landing page visuals, icons and app UI assets." },
      { icon: "Layout", title: "Presentations", text: "Professional pitch decks and company profiles that impress clients." },
      { icon: "Layers", title: "Infographics", text: "Complex information turned into clear, shareable visual stories." },
    ],
    packages: [
      { name: "Starter", price: "4,999", unit: "/project", features: ["Logo design (2 concepts)", "2 revisions", "PNG, JPG & PDF files", "Delivery in 5 days"] },
      { name: "Business", price: "14,999", unit: "/project", featured: true, features: ["Logo + brand identity", "Business card & letterhead", "10 social media creatives", "Unlimited revisions", "Source files included"] },
      { name: "Monthly", price: "24,999", unit: "/month", features: ["30 social media creatives", "Ad creatives", "Dedicated designer", "Priority support"] },
    ],
    faqs: [
      { q: "How many revisions do I get?", a: "Every package includes revisions, and our Business package includes unlimited revisions until you are fully happy with the design." },
      { q: "Will I get the source files?", a: "Yes. Business and Monthly packages include editable source files (AI, PSD or Figma) along with all export formats." },
      { q: "How long does a logo take?", a: "Most logo projects are delivered within 5 to 7 working days, depending on feedback and revisions." },
    ],
  },
  {
    slug: "video-editing",
    title: "Video Editing",
    icon: "Film",
    iconBg: "",
    summary:
      "Professional editing for reels, YouTube, ads, corporate films and events with colour grading and sound design.",
    intro: [
      "Raw footage becomes a story in the edit. Our editors cut, grade and polish your videos so they hold attention from the first second to the last.",
      "From short-form reels to long-form YouTube content and corporate films, we handle editing, colour correction, motion titles, music and sound design, all delivered in the formats each platform needs.",
    ],
    offerings: [
      { icon: "Smartphone", title: "Reels & Shorts", text: "Fast-paced vertical edits optimised for Instagram, YouTube Shorts and more." },
      { icon: "Youtube", title: "YouTube Videos", text: "Engaging long-form edits with captions, b-roll, thumbnails and intros." },
      { icon: "Briefcase", title: "Corporate Videos", text: "Brand films, testimonials, explainers and training videos." },
      { icon: "Heart", title: "Wedding & Event Films", text: "Cinematic highlight films and full-length event edits." },
      { icon: "Sun", title: "Colour Grading", text: "Consistent, cinematic looks that match your brand and mood." },
      { icon: "Music", title: "Sound Design", text: "Music selection, audio clean-up, voice-over sync and mixing." },
    ],
    packages: [
      { name: "Reel", price: "1,499", unit: "/video", features: ["Up to 60 seconds", "Captions & music", "2 revisions", "Delivery in 2 days"] },
      { name: "YouTube", price: "4,999", unit: "/video", featured: true, features: ["Up to 15 minutes", "Colour grading", "Motion titles & b-roll", "Thumbnail design", "3 revisions"] },
      { name: "Monthly", price: "29,999", unit: "/month", features: ["20 reels or 6 long videos", "Dedicated editor", "Content calendar support", "Priority delivery"] },
    ],
    faqs: [
      { q: "How do I send you my footage?", a: "You can share footage via Google Drive, Dropbox, WeTransfer or any cloud link. For large projects we can also collect drives in person." },
      { q: "What software do you use?", a: "We edit in Adobe Premiere Pro and DaVinci Resolve, with After Effects for motion graphics." },
      { q: "What is the turnaround time?", a: "Reels are typically delivered in 1 to 2 days and long-form videos in 3 to 5 days." },
    ],
  },
  {
    slug: "photo-shoot",
    title: "Photo Shoot",
    icon: "Camera",
    iconBg: "bg-c679e3",
    summary:
      "Product, fashion, portrait, food and event photography with professional lighting and retouching.",
    intro: [
      "Strong photos sell products, build trust and make your brand look premium. Our photographers bring professional cameras, lighting and creative direction to every shoot.",
      "We shoot in our studio or on location, and every package includes professional retouching so your images are ready for your website, social media, catalogues and ads.",
    ],
    offerings: [
      { icon: "ShoppingBag", title: "Product Photography", text: "Clean white-background and lifestyle shots for e-commerce and catalogues." },
      { icon: "User", title: "Portrait & Headshots", text: "Professional headshots for teams, founders and personal branding." },
      { icon: "Star", title: "Fashion & Model Shoots", text: "Lookbooks, campaigns and portfolio shoots with creative styling." },
      { icon: "Coffee", title: "Food Photography", text: "Mouth-watering menu and social media shots for restaurants and cafés." },
      { icon: "Users", title: "Event Photography", text: "Corporate events, launches, parties and weddings captured beautifully." },
      { icon: "Image", title: "Retouching", text: "Colour correction, background removal and high-end skin retouching." },
    ],
    packages: [
      { name: "Basic", price: "7,999", unit: "/shoot", features: ["2 hour shoot", "1 photographer", "20 edited photos", "Online gallery"] },
      { name: "Standard", price: "14,999", unit: "/shoot", featured: true, features: ["Half-day shoot (4 hours)", "Studio lighting setup", "50 edited photos", "Advanced retouching", "All raw files"] },
      { name: "Premium", price: "24,999", unit: "/shoot", features: ["Full-day shoot (8 hours)", "2 photographers", "100+ edited photos", "Creative direction"] },
    ],
    faqs: [
      { q: "Do you shoot on location?", a: "Yes. We shoot in our studio or at your location, whether that is your office, store, restaurant or an outdoor venue." },
      { q: "When will I receive my photos?", a: "Edited photos are usually delivered within 5 to 7 working days through a private online gallery." },
      { q: "Can you arrange models and props?", a: "Yes, we can arrange models, stylists, makeup artists and props on request at an additional cost." },
    ],
  },
  {
    slug: "video-shoot",
    title: "Video Shoot",
    icon: "Video",
    iconBg: "bg-c679e3",
    summary:
      "Ad films, brand stories, product videos, interviews and events shot in 4K with a professional crew.",
    intro: [
      "Video is the most powerful way to tell your story. Our production team handles everything from concept and scripting to shooting with cinema cameras, lighting and professional audio.",
      "Combine your shoot with our video editing service and get a finished, ready-to-publish film from a single team.",
    ],
    offerings: [
      { icon: "Tv", title: "Ad Films & Commercials", text: "High-impact ads for TV, YouTube and social media campaigns." },
      { icon: "Award", title: "Brand Films", text: "Tell your company story, culture and values on screen." },
      { icon: "Package", title: "Product Videos", text: "Showcase features, unboxing and demos that convert viewers." },
      { icon: "Mic", title: "Interviews & Podcasts", text: "Multi-camera setups with clean, professional audio." },
      { icon: "Calendar", title: "Event Coverage", text: "Conferences, launches, concerts and weddings filmed end to end." },
      { icon: "Edit3", title: "Concept & Scripting", text: "Creative ideas, storyboards and scripts before the camera rolls." },
    ],
    packages: [
      { name: "Basic", price: "14,999", unit: "/shoot", features: ["Half-day shoot", "1 camera operator", "4K footage", "1-minute edited video"] },
      { name: "Professional", price: "34,999", unit: "/shoot", featured: true, features: ["Full-day shoot", "2-camera setup", "Lighting & audio crew", "3-minute edited film", "2 reels cut-downs"] },
      { name: "Production", price: "On request", unit: "", features: ["Concept & scripting", "Full crew & equipment", "Talent & location", "Complete post-production"] },
    ],
    faqs: [
      { q: "What equipment do you use?", a: "We shoot in 4K on professional cinema and mirrorless cameras with gimbals, studio lights and wireless microphones." },
      { q: "Do you help with the idea and script?", a: "Yes. Our Production package includes concept development, scripting and storyboarding." },
      { q: "Is editing included?", a: "Basic and Professional packages include an edited video. Additional edits can be added from our video editing service." },
    ],
  },
  {
    slug: "drone-shoot",
    title: "Drone Shoot",
    icon: "Navigation",
    iconBg: "bg-eb6b3d",
    summary:
      "Breathtaking aerial photos and videos for real estate, events, weddings, construction and tourism.",
    intro: [
      "Aerial shots add a cinematic, high-end feel that ground cameras simply cannot capture. Our licensed drone pilots fly professional drones to capture stunning 4K aerial footage and photos.",
      "We handle flight planning and permissions so your shoot is safe, legal and delivered on time.",
    ],
    offerings: [
      { icon: "Home", title: "Real Estate", text: "Aerial views of properties, plots and projects that help them sell faster." },
      { icon: "Heart", title: "Weddings & Events", text: "Cinematic aerial shots that make your event film unforgettable." },
      { icon: "Tool", title: "Construction Progress", text: "Regular site updates and progress documentation from above." },
      { icon: "Map", title: "Tourism & Hospitality", text: "Showcase resorts, hotels and destinations from stunning angles." },
      { icon: "Maximize", title: "Mapping & Surveys", text: "High-resolution aerial imagery for planning and inspection." },
      { icon: "Aperture", title: "Aerial Photography", text: "High-resolution stills perfect for brochures, websites and ads." },
    ],
    packages: [
      { name: "Basic", price: "9,999", unit: "/shoot", features: ["1 hour flight time", "4K aerial footage", "15 aerial photos", "Raw footage delivery"] },
      { name: "Standard", price: "19,999", unit: "/shoot", featured: true, features: ["Half-day coverage", "4K footage & photos", "1-minute edited aerial video", "Colour grading", "Licensed pilot"] },
      { name: "Event", price: "29,999", unit: "/event", features: ["Full-day event coverage", "Unlimited flights (weather permitting)", "Highlight film", "Combine with video shoot"] },
    ],
    faqs: [
      { q: "Are your drone pilots licensed?", a: "Yes. Our pilots are trained and licensed, and we follow all local drone regulations." },
      { q: "Do you handle permissions?", a: "We help plan the flight and apply for the required permissions for the location, which may add lead time for restricted areas." },
      { q: "What happens if the weather is bad?", a: "Drones cannot fly safely in rain or strong wind. If the weather is unsuitable we reschedule your shoot at no extra cost." },
    ],
  },
  {
    slug: "motion-graphics",
    title: "Motion Graphics",
    icon: "PlayCircle",
    iconBg: "bg-eb6b3d",
    summary:
      "Animated explainers, logo animations, titles and social media motion content that brings ideas to life.",
    intro: [
      "Motion graphics explain complex ideas simply and grab attention in crowded feeds. Our animators combine design, typography and movement to create content people actually watch.",
      "From a 5-second logo reveal to a full 2D explainer video, we handle scripting, illustration, animation, voice-over and music.",
    ],
    offerings: [
      { icon: "Zap", title: "Logo Animation", text: "Eye-catching logo reveals for videos, intros and presentations." },
      { icon: "HelpCircle", title: "Explainer Videos", text: "2D animated videos that explain your product or service clearly." },
      { icon: "Type", title: "Kinetic Typography", text: "Animated text videos for quotes, announcements and ads." },
      { icon: "Instagram", title: "Social Motion Posts", text: "Animated posts and stories that stop the scroll." },
      { icon: "BarChart2", title: "Animated Infographics", text: "Data and stats brought to life with smooth animation." },
      { icon: "Sliders", title: "Titles & Lower Thirds", text: "Custom animated titles and overlays for your videos." },
    ],
    packages: [
      { name: "Logo Reveal", price: "2,999", unit: "/video", features: ["5 to 10 seconds", "Sound effect", "2 revisions", "HD & 4K export"] },
      { name: "Explainer", price: "19,999", unit: "/video", featured: true, features: ["Up to 60 seconds", "Script & storyboard", "Custom illustrations", "Voice-over & music", "3 revisions"] },
      { name: "Monthly", price: "34,999", unit: "/month", features: ["15 animated posts", "2 short explainers", "Dedicated animator", "Priority support"] },
    ],
    faqs: [
      { q: "Do you write the script?", a: "Yes. Our Explainer package includes scriptwriting and storyboarding, which you approve before animation begins." },
      { q: "Can you use my brand colours and fonts?", a: "Absolutely. All animations follow your brand guidelines so they stay consistent with the rest of your content." },
      { q: "How long does an explainer take?", a: "A 60-second explainer usually takes 2 to 3 weeks from script approval to final delivery." },
    ],
  },
]

module.exports = creativeServices
